import { http, HttpResponse, RequestHandler } from 'msw';
import { postsHandlers } from './postsMocks/postHandlers';
import { usersHandlers } from './usersMocks/userHandlers';

export type mockRequestHandler = {
  endpoint: string
  // Do I need to add type safety from scheme for each url?
  response: (args: { pathParams: Record<string, string>, query: Record<string, string>, payload: Record<string, any> }) => Record<string, any>
  method: 'get' | 'post' | 'delete'
};

const allHandlerObjects: mockRequestHandler[] = [
  ...postsHandlers,
  ...usersHandlers,
];

const base_url = 'https://joinzylo.com'; //for now
const makeHandlers: () => RequestHandler[] = () => {
  return allHandlerObjects.map(({ endpoint, response, method }) => {
    const fullUrl = base_url + endpoint;
    const m = method || 'get';
    return http[m](fullUrl, async ({ request, params }) => {
      const url = new URL(request.url);
      let payload = {};
      if (m === 'post') {
        payload = await request.json() as Record<string, any>;
      }
      const entries = url.searchParams.entries();
      const queryObject = Array.from(entries).reduce((acc, curr) => ({ ...acc, [curr[0]]: curr[1] }), {});
      const pathParams = Object(params);
      return HttpResponse.json(response({ pathParams, query: queryObject, payload }));
    });
  });
};

export const handlers = makeHandlers();
